(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alliance-pro-wrapper"] && !Shopify.designMode) return;
  try {
    const emailLabel = document.querySelector('.field__label[for="application_email"]');
    if (emailLabel) emailLabel.textContent = 'Work Email';

    const fileInput = document.querySelector('#fileInput');
    const fileLabel = fileInput?.parentElement?.parentElement?.previousElementSibling?.querySelector('p');
    if (fileLabel) {
      fileLabel.innerHTML = `Please upload one of the following (Required):<br>
        Paystub from the last 30 days (Please black out any sensitive information)<br>
        Business card<br>
        W2 (Please black out any sensitive information)<br>
        Professional certifications (AMGA/IFMGA)<br>
        PSIA or AASI Membership card`;
    }

    const provinceLabel = document.querySelector('.field__label[for="application_province"]');
    if (provinceLabel) provinceLabel.textContent = 'State';

    const countrySelect = document.querySelector('#application_country');
    if (countrySelect) {
      Array.from(countrySelect.options).forEach((option) => {
        if (option.value !== 'United States') option.remove();
      });
      countrySelect.value = 'United States';
    }

    const successAlert = document.querySelector('.alert.alert-success');
    if (successAlert) {
      successAlert.textContent =
        'Application submitted successfully! Watch your inbox for an update from ALLIANCE PRO with next steps about your membership.';
    }

    const termsLabel1 = document.querySelector('label[for="application_terms_and_conds_1_agreed"]');
    if (termsLabel1) termsLabel1.insertAdjacentText('beforeend', ' (Required)');

    const termsLabel2 = document.querySelector('label[for="application_terms_and_conds_2_agreed"]');
    if (termsLabel2) termsLabel2.insertAdjacentText('beforeend', ' (Required)');

    const termsContentEl = document.querySelectorAll('.policy-field-wrapper')[0]?.querySelector('.details-scrollable');
    if (termsContentEl) {
      termsContentEl.innerHTML = termsContentEl.innerHTML.replace(
        /\|\|terms_link\|\|/g,
        '<a href="/policies/terms-of-service" target="_blank" rel="noopener noreferrer" title="Terms of Service">Terms of Service<span class="visually-hidden"> Opens in a new window.</span></a>',
      );
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    if (!window.__textBlockReadMoreInitialized) {
    window.__textBlockReadMoreInitialized = true;

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-text-block-toggle]');
      if (!toggle) return;

      var container = toggle.closest('[data-text-block]');
      if (!container) return;

      var expanded = container.getAttribute('data-expanded') === 'true';
      var newExpanded = !expanded;

      container.setAttribute('data-expanded', newExpanded ? 'true' : 'false');
      toggle.classList.toggle('active', newExpanded);

      var readMoreLabel = toggle.getAttribute('data-read-more-label') || 'Read more';
      var readLessLabel = toggle.getAttribute('data-read-less-label') || 'Read less';

      toggle.textContent = newExpanded ? readLessLabel : readMoreLabel;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-collection-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__variantCollectionSwatchesInitialized) return;
    window.__variantCollectionSwatchesInitialized = true;

    /**
     * @param {HTMLElement} swatchesRoot
     * @param {HTMLElement} label
     */
    function applyVariant(swatchesRoot, label, { updatePriceAndLink }) {
      var card = swatchesRoot.closest('product-card');
      if (!card) return;

      var mediaId = label.dataset.mediaId;
      if (mediaId) {
        var images = card.querySelectorAll('[data-variant-image]');
        images.forEach(function (image) {
          image.hidden = image.dataset.mediaId !== mediaId;
        });
      }

      if (!updatePriceAndLink) return;

      var variantUrl = label.dataset.variantUrl;
      var variantId = label.dataset.variantId;
      if (!variantUrl || !variantId) return;

      // Update every link that navigates to the product (card overlay + gallery link).
      card.querySelectorAll('a.product-card__link, a.card-gallery__link').forEach(function (link) {
        link.href = variantUrl;
      });

      // Swap the price display using the pre-rendered markup for this variant. A card can
      // contain more than one .regios-dopp-generic-price-container (e.g. the zoom-out grid
      // view renders its own copy alongside the main price block), so update all of them.
      var priceTemplate = label.closest('li')?.querySelector('[data-variant-price-template]');
      if (priceTemplate) {
        var fresh = priceTemplate.content
          ? priceTemplate.content.firstElementChild
          : new DOMParser().parseFromString(priceTemplate.innerHTML, 'text/html').body.firstElementChild;
        if (fresh) {
          card.querySelectorAll('.regios-dopp-generic-price-container').forEach(function (priceContainer) {
            if (priceContainer.parentElement) {
              priceContainer.replaceWith(fresh.cloneNode(true));
            }
          });
        }
      }

      // Sync the Regios DOPP discount attributes to the new variant, then ask it to
      // recalculate (it exposes this specifically for cases like this one).
      var doppEl = card.querySelector(
        '[data-regios-dopp-product-id][data-regios-dopp-variant-id][data-regios-dopp-regular-price-cents]',
      );
      if (doppEl) {
        doppEl.setAttribute('data-regios-dopp-variant-id', variantId);
        doppEl.setAttribute('data-regios-dopp-regular-price-cents', label.dataset.variantPriceCents || '');
        if (label.dataset.variantCompareAtPriceCents) {
          doppEl.setAttribute('data-regios-dopp-compare-at-price-cents', label.dataset.variantCompareAtPriceCents);
        } else {
          doppEl.removeAttribute('data-regios-dopp-compare-at-price-cents');
        }
        if (window.RegiosDoppThemeInterop) {
          window.RegiosDoppThemeInterop.ensureApiThenUpdate(card);
        }
      }
    }

    document.addEventListener('pointerover', function (event) {
      if (event.pointerType !== 'mouse') return;
      var label = event.target.closest('[data-variant-swatch]');
      if (!label) return;
      var root = label.closest('[data-variant-collection-swatches]');
      if (!root) return;
      var relatedLabel =
        event.relatedTarget instanceof Element ? event.relatedTarget.closest('[data-variant-swatch]') : null;
      if (relatedLabel === label) return;
      applyVariant(root, label, { updatePriceAndLink: false });
    });

    document.addEventListener('pointerout', function (event) {
      if (event.pointerType !== 'mouse') return;
      var label = event.target.closest('[data-variant-swatch]');
      if (!label) return;
      var root = label.closest('[data-variant-collection-swatches]');
      if (!root || root.contains(event.relatedTarget)) return;
      var checked = root.querySelector('[data-variant-swatch] input:checked');
      var checkedLabel = checked ? checked.closest('[data-variant-swatch]') : null;
      if (checkedLabel) {
        applyVariant(root, checkedLabel, { updatePriceAndLink: false });
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      var label = input.closest('[data-variant-swatch]');
      var root = label ? label.closest('[data-variant-collection-swatches]') : null;
      if (!label || !root) return;
      applyVariant(root, label, { updatePriceAndLink: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
